import React, { useState } from "react";
import Lottie from "lottie-react";
import GirlSvg from "../assets/images/sezione-04-img-01.svg";
import LottieImg from "../assets/json/sezione-04-img-01";
import OutlineSvg from "../assets/images/sezione-03-img-02.svg";
import arrowIcon from "../assets/images/Vector_btn.png";
import BackSection from "../assets/images/bkg_azzurro.svg";
import Sezione4popupNumeri from "./popup/en/en-sezione-4-popup-1-numeri";
import Sezione4popup2 from "./popup/en/en-sezione-4-popup-2";
import PopupImpegnoPersone from "./popup/en/en-sezione-4-popup-3";


export default function Sezione4EN() {

  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  
  return (
    <>
    <section id="sezione-numeri" className="w-full bg-[#F7B500] pt-10 md:pt-24" 
        style={{
            backgroundImage: `url(${BackSection})`,
            backgroundSize: 'cover',
        }}>

      <h2 className="mb-5 md: px-6 block md:hidden text-[#fff]">
              Our figures
      </h2>

      <div className="mx-auto xl:w-[1440px] px-4 md:px-5 xl:px-0 flex flex-row gap-5 md:gap-0">

        

        {/* Colonna sinistra */}
        <div className="w-1/2 md:w-1/3 flex justify-center md:justify-start">
          <Lottie 
            animationData={LottieImg}
            loop
            autoplay
          />
        </div>

        {/* Colonna destra */}
        <div className="w-1/2 md:w-2/3 flex pb-10 md:pb-0">
          {/* Box con bordo SVG come background */}
          <div
            className="bg-no-repeat bg-center flex flex-col justify-center items-start p-0 md:px-[80px]"
          >

              <h2 className=" text-[#fff] mb-1">
                Our figures
              </h2>

            {/* Stats + lista comparti */}
            <div className="grid grid-cols-1 md:grid-cols-3 items-start gap-8 md:gap-3">
                <div className="flex flex-col md:pr-5 md:my-5 items-start">    
                    <div className="text-[#fff] font-bold text-[18px] md:text-[20px] text-left">Value<br/>distribution</div>    
                    <button 
                      className="bt-secondary my-2 md:my-5 flex items-start gap-2"
                      onClick={() => setOpen1(true)}
                      >
                        <img src={arrowIcon} alt="" className="w-[24px] h-[24px]" />
                            Discover more
                    </button>
                </div>
                <div className="flex flex-col md:pr-5 md:my-5 items-start">    
                    <div className="text-[#fff] font-bold text-[18px] md:text-[20px] text-left">Income and<br/>financial position</div>    
                    <button 
                      className="bt-secondary my-2 md:my-5 flex items-start gap-2"
                      onClick={() => setOpen2(true)}
                      >
                        <img src={arrowIcon} alt="" className="w-[24px] h-[24px]" />
                            Discover more
                    </button>
                </div>
                <div className="flex flex-col md:pr-0 md:my-5 items-start">    
                    <div className="text-[#fff] font-bold text-[18px] md:text-[20px] text-left">Discover more Commitment in favour of people in the area</div>    
                    <button 
                      className="bt-secondary my-2 md:my-5 flex items-start gap-2"
                      onClick={() => setOpen3(true)}
                      >
                        <img src={arrowIcon} alt="" className="w-[24px] h-[24px]" />
                            Discover more
                    </button>

                    <a href="https://realefoundation.org/en/" target="_blank" className="hidden">
                      <button 
                        className="bt-secondary my-1 flex items-start gap-2"
                        style={{fontSize: "16px", padding: "8px"}}
                        >
                          <img src={arrowIcon} alt="" className="w-[24px] h-[24px]" />
                              Discover Reale Foundation
                      </button>
                    </a>

                    <a href="https://realefoundation.org" target="_blank" className="hidden">
                      <button 
                        className="bt-secondary my-1 flex items-start gap-2"
                        style={{fontSize: "10px", padding: "5px"}}
                        >
                          <img src={arrowIcon} alt="" className="w-[24px] h-[24px]" />
                              Discover Reale Foundation
                      </button>
                    </a>
                    
                </div>
            </div>

          </div>
        </div>
      </div>
    </section>

    <Sezione4popupNumeri isOpen={open1} onClose={() => setOpen1(false)} />
    <Sezione4popup2 isOpen={open2} onClose={() => setOpen2(false)} />
    <PopupImpegnoPersone isOpen={open3} onClose={() => setOpen3(false)} />

    </>
  );
}
